/*
 * @Author: your name
 * @Date: 2021-12-14 10:20:06
 * @LastEditTime: 2021-12-14 16:55:13
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \lzxy-homepage\src\commons\productTreeModel.ts
 */

export class ProductDetail {
  id: string
  pid: string
  upshelfId: string
  title: string
  url: string
  constructor (
    id: string,
    pid: string,
    upshelfId: string,
    title: string,
    url: string
  ) {
    this.id = id
    this.pid = pid
    this.upshelfId = upshelfId
    this.title = title
    this.url = url
  }
}
